import { createContext } from 'react'

export const CheckoutCartContext = createContext([])
